<template>
    <app-table
        deletable
        :data="items"
        :highlight-rows-on-hover="true"
        @deleteRow="deleteItem"
        v-if="currencies && currencies.length > 0"
    >
        <template slot="secondary_header" v-if="isNewPriceAddAllowed">
            <div class="status search" style="min-height: 1px !important;" />
            <form class="filter expand_content open" @submit.prevent="submitForm">
                <div class="field_left">
                    <app-table-header-select :label="$gettext('Měna')">
                        <app-select
                            id="newIdCurrency"
                            :options="currencyOptions"
                            selectId="newIdCurrency"
                            name="idCurrency"
                            v-model="newInstance.idCurrency"
                        />
                    </app-table-header-select>
                </div>

                <div class="field_left">
                    <app-input
                        id="newPriceValue"
                        type="number"
                        :step="0.001"
                        :label="$gettext('Částka')"
                        v-model="newInstance.value"
                    />
                </div>

                <div class="field_right">
                    <app-content-save-button />
                </div>
            </form>
        </template>

        <app-table-column first :label="$gettext('Měna')">
            <template slot-scope="row">
                {{ currenciesById[row.idCurrency].name }} ({{currenciesById[row.idCurrency].isoCode}})
            </template>
        </app-table-column>
        <app-table-column :label="$gettext('Částka')">
            <template slot-scope="row">
                {{ formatAmount(row.value, currenciesById[row.idCurrency].format) }}
            </template>
        </app-table-column>
    </app-table>
</template>

<script>
import {mapActions} from "vuex";

export default {
    name: "prices",
    emits: ['pricesChanged'],
    data() {
        return {
            newInstance: this.createNewInstance(),
            items: this.item.prices || [],
            currencies: [],
        }
    },
    created() {
        this.getCurrencies({ order: 'name' }).then((response) => {
            this.currencies = response.data.data;
        });
    },
    props: {
        item: {
            type: Object,
            default: null,
        }
    },
    methods: {
        ...mapActions([
            'getCurrencies',
        ]),
        formatAmount(value, pattern) {
            value = parseFloat(value);
            const match = pattern.match(/[#.,]+/);
            if (!match) throw new Error("Invalid pattern");

            const numberPattern = match[0];
            const separator = numberPattern.includes('.') ? '.' : numberPattern.includes(',') ? ',' : null;

            let formattedNumber;
            if (separator) {
                const decimals = numberPattern.split(separator)[1].length || 0;

                const fixed = value.toFixed(decimals);
                const [intPart, decPart] = fixed.split('.');
                formattedNumber = intPart + separator + decPart;
            } else {
                formattedNumber = Math.floor(value).toString();
            }

            return pattern.replace(numberPattern, formattedNumber);
        },
        deleteItem(itemToDelete) {
            this.items = this.items.filter((item) => item !== itemToDelete);
            this.item.prices = [...this.items];

            this.updateEntity();
        },
        createNewInstance() {
            return {
                idCurrency: '',
                value: '',
            }
        },
        submitForm(evt) {
            if (!this.newInstance.idCurrency || !this.newInstance.value) {
                return false;
            }

            this.newInstance.value = parseFloat(parseFloat(this.newInstance.value).toFixed(2));

            if (!this.items) {
                this.items = [this.newInstance];
            } else {
                this.items.push(this.newInstance);
            }

            this.item.prices = [...this.items];
            this.newInstance = this.createNewInstance();

            this.updateEntity();
        },
        updateEntity() {
            this.$emit("pricesChanged", {
                params: {
                    id: this.item._id,
                },
                data: {
                    prices: this.items,
                }
            });
        },
    },
    computed: {
        availableCurrencies() {
            const filteredCurrencies = [];

            this.currencies.forEach((currency) => {
                if (this.items.findIndex((item) => {
                    return item.idCurrency === currency._id;
                }) < 0) {
                    filteredCurrencies.push(currency);
                }
            });

            return filteredCurrencies;
        },
        isNewPriceAddAllowed() {
            return this.availableCurrencies.length > 0;
        },
        currencyOptions() {
            const values = [];

            this.availableCurrencies.forEach((currency) => {
                values.push({
                    name: currency.name + " (" + currency.symbol + "; " + currency.isoCode + ") ",
                    value: currency._id
                })
            })

            return values;
        },
        currenciesById() {
            const currencies = {};

            this.currencies.forEach((currency) => {
                currencies[currency._id] = currency;
            })

            return currencies;
        }
    }
}
</script>

